import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

import { distances } from '../../../../styles/constants';
import { Search } from '../../../../components/Filters';
import { Button } from '../../../../components/Buttons';
import Icon from '../../../../components/Icons';


interface FiltersProps extends WithTranslation {
    q: string;
    onChange: (q: string) => void;
    refresh: () => void;
}

class Filters extends Component<FiltersProps> {
    render() {
        const { t, q, onChange, refresh } = this.props;
        return (
            <FilterRowWrapper>
                <FilterComponentWrapper>
                    <Button className="alt tiny" onClick={refresh} title={t('customers.customer.receipts.filter.refresh')}>
                        <Icon icon="refresh"/>
                    </Button>
                </FilterComponentWrapper>
                <RightAligned>
                    <Search
                        name="search"
                        placeholder={t('customers.customer.receipts.filter.search_placeholder')}
                        defaultValue={q || ''}
                        onChange={value => onChange(value)}
                        onBlur={() => {
                        }}
                    />
                </RightAligned>
            </FilterRowWrapper>
        );
    }
}

const FilterComponentWrapper = styled.div`
    & > * {
        margin-right: ${distances.tiny};
    }
`;

const RightAligned = styled.div`
    margin-left: auto;
`;

const FilterRowWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding: ${distances.normal};
    padding-bottom: ${distances.tiny};

    @media (max-width: 768px) {
        padding: ${distances.tiny};
    }
`;

export default withTranslation()(Filters);
